import React from 'react';
import { FieldArray } from 'redux-form';
import { TextInput } from 'app/components/FormFields/TextInput';
import { Currency } from 'app/components/FormFields/Currency';
import { Select } from 'app/components/FormFields/Select';
import { SingleFutureDate } from 'app/components/FormFields/SingleFutureDate';
import { Button } from 'app/components/Button';
import { FieldNames } from 'app/models/fields/names';
import { requiredArray } from 'app/util/validators';
import { equipmentListInitialValue } from 'app/util/initial-values';
import { FormControl } from '@mui/material';
import { useTranslation } from 'react-i18next';

const EQUIPMENT_CONDITION_OPTIONS = [
  { title: 'New',         value: 'New' },
  { title: 'Used',        value: 'Used' },
  { title: 'Addition',    value: 'Addition' },
  { title: 'Replacement', value: 'Replacement' },
];

const RenderEquipmentListComponent = ({ ...props }) => {
  const { fields, name } = props;
  const { t } = useTranslation();

  React.useEffect(() => {
    if (fields.length === 0) {
      fields.push(equipmentListInitialValue);
    }
  }, [fields]);

  const renderFields = () =>
    fields.map((field, index) => {
      const item      = fields.get(index);
      const condition = item ? item[FieldNames.equipmentCondition] : null;

      return (
        <div key={`${field}-${index}`} style={{ paddingBottom: 20 }}>
          <TextInput
            label = 'Equipment Description'
            name  = {`${field}.${FieldNames.commercialEquipmentDescription}`}
          />
          <SingleFutureDate
            label = 'Equipment Delivery Date'
            name  = {`${field}.${FieldNames.equipmentDeliveryDate}`}
          />
          <Select
            label   = 'Equipment Condition'
            name    = {`${field}.${FieldNames.equipmentCondition}`}
            options = {EQUIPMENT_CONDITION_OPTIONS}
          />
          {condition === 'Replacement' && (
            <TextInput
              label = 'How old is existing equipment?'
              name  = {`${field}.${FieldNames.existingEquipmentAge}`}
            />
          )}
          {condition === 'Addition' && (
            <TextInput
              label = 'Why addition?'
              name  = {`${field}.${FieldNames.equipmentAdditionReason}`}
            />
          )}
          <Currency
            label = 'Equipment Cost'
            name  = {`${field}.${FieldNames.equipmentCost}`}
          />
          {fields.length > 1 && (
            <Button
              disableRipple
              color   = 'primary'
              classes = {{ root: 'link', text: 'remove' }}
              onClick = {() => fields.remove(index)}
            >
              {t(`question.${name}.button.remove`, { defaultValue: 'Remove' })}
            </Button>
          )}
        </div>
      );
    });

  return (
    <div>
      {renderFields()}
      <Button
        color    = 'primary'
        disabled = {props.meta.invalid}
        variant  = 'outlined'
        classes  = {{ root: 'add' }}
        onClick  = {() => fields.push(equipmentListInitialValue)}
      >
        {t(`question.${name}.button.add`, { defaultValue: '+ Add Equipment' })}
      </Button>
    </div>
  );
};

export const EquipmentListComponent = ({ ...props }) => {
  const { name } = props;
  const { t }    = useTranslation();
  return (
    <FormControl fullWidth>
      <FieldArray
        component = {RenderEquipmentListComponent}
        name      = {name}
        validate  = {[requiredArray([FieldNames.commercialEquipmentDescription, FieldNames.equipmentCost])]}
        props     = {{ name, t }}
      />
    </FormControl>
  );
};
